export type LockedFeatureCopy = {
  title: string;
  description: string;
  featureName: string;
  screenshot?: string;
};

export const LOCKED_FEATURE_COPY: Record<string, LockedFeatureCopy> = {
  canUseManagerWorkflows: {
    title: "Workflow Builder locked",
    description: "Design new automations, attach agents, and publish multi-step workflows once you upgrade.",
    featureName: "Workflow Builder",
  },
  canUseAdvancedHitl: {
    title: "Advanced HITL controls",
    description: "Unlock approve/reject + request-changes tooling so reviewers can steer AI safely.",
    featureName: "HITL actions",
  },
  canUseBookingAI: {
    title: "AI booking leads",
    description: "Score, enrich, and auto-sync routing-ready leads with Bandsintown + CRM context.",
    featureName: "Booking AI",
  },
  canUseRoutingAdvisor: {
    title: "Routing advisor",
    description: "Simulate drives, lock routing strategies, and spin up venue briefs with the advisor.",
    featureName: "Routing advisor",
  },
  canUseSettlementPreview: {
    title: "Event settlements",
    description: "Preview net + merch splits instantly with ledger automation and auto rollups.",
    featureName: "Settlement preview",
  },
  canUseMemoryBrowser: {
    title: "Memory Browser",
    description: "Search agents' shared memory graph by metadata, embeddings, or CRM filters.",
    featureName: "Memory Browser",
  },
  canUseMemoryGraph: {
    title: "Memory Graph intelligence",
    description: "Visualize knowledge graphs and link reasoning insights once you upgrade.",
    featureName: "Memory Graph",
  },
  canUseEmailAI: {
    title: "AI email generation",
    description: "Draft touring outreach, post-show follow-ups, and deal memos in one click.",
    featureName: "Email AI",
  },
  canUseGlobalAutopilot: {
    title: "Global autopilot",
    description: "Run orchestration sweeps that trigger agents, workflows, and HITL escalations automatically.",
    featureName: "Global Autopilot",
  },
  "observability.frontend": {
    title: "Frontend error observability",
    description: "Surface client-side crashes, runtime errors, and SWR issues in a central observability feed.",
    featureName: "Frontend Error Logs",
  },
  "podcast.basic": {
    title: "Podcast Studio",
    description: "Upgrade to unlock podcast series planning, episode boards, and script tooling.",
    featureName: "Podcast Studio",
  },
  "podcast.pro": {
    title: "Podcast Pro workflows",
    description: "Fact-check, panel reviews, and audio QA live in the Pro toolkit.",
    featureName: "Podcast Pro",
  },
};

export function getLockedFeatureCopy(flag?: string): LockedFeatureCopy | undefined {
  if (!flag) return undefined;
  return LOCKED_FEATURE_COPY[flag];
}
